import Swiper from 'swiper';
import anime from 'animejs';

export function index(){
};